import { Link } from "react-router-dom";
import { Container, Title, Message, BackButton } from "./styles";

export default function NotFound() {
    return (
        <Container>
            <Title>404</Title>
            <Message>Página não encontrada</Message>
            <Link to={'/'} className="button_back">
                Voltar ao início
            </Link>
        </Container>
    );
}
